'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useSyncExternalStore } from 'react';
import i18n, { initI18n } from '@/lib/i18n/config';
import type { AppLanguage } from '@/lib/i18n/constants';
import { normalizeLanguage } from '@/lib/i18n/constants';
import { getLandingLanguage, setLandingLanguage } from '@/lib/i18n/landing-language-storage';
import { syncLandingDocumentMeta } from '@/lib/i18n/landing-document-meta';
function subscribe(onStoreChange: () => void) {
  const handler = () => onStoreChange();
  i18n.on('languageChanged', handler);
  return () => i18n.off('languageChanged', handler);
}
function getSnapshot(): AppLanguage {
  return normalizeLanguage(i18n.language || getLandingLanguage());
}
export function applyLandingLanguage(lang: AppLanguage): void {
  const normalized = normalizeLanguage(lang);
  setLandingLanguage(normalized);
  initI18n(normalized);
  if (i18n.isInitialized && normalizeLanguage(i18n.language) !== normalized) {
    i18n.changeLanguage(normalized);
  }
  syncLandingDocumentMeta(normalized);
}
export function useLandingLanguage() {
  const $ = _c(2);
  const language = useSyncExternalStore(subscribe, getSnapshot, _temp);
  const setLanguage = _temp2;
  let t0;
  if ($[0] !== language) {
    t0 = {
      language,
      setLanguage
    };
    $[0] = language;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp2(lang) {
  applyLandingLanguage(lang);
}
function _temp() {
  return getLandingLanguage();
}